import React, { useEffect, useState } from 'react'
import { Button, Checkbox, Popover, Box } from '@mui/material'
import '../../../../../style/filters.css'

const PriorityFilter = ({ filterList, onChange, index, column, filterOptions }) => {
  const [tempFilters, setTempFilters] = useState(filterList || [])
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleChange = (event) => {
    const { value, checked } = event.target
    setTempFilters((prev) => (checked ? [...prev, value] : prev.filter((item) => item !== value)))
  }

  const handleApply = () => {
    const cleaned = tempFilters.filter(Boolean)
    onChange(cleaned, index, column)
    handleClose()
  }

  const handleReset = () => {
    setTempFilters([])
    onChange([], index, column)
    handleClose()
  }

  const open = Boolean(anchorEl)
  const id = open ? 'priority-filter-popover' : undefined

  useEffect(() => {
    if (open) {
      setTempFilters(filterList || [])
    }
  }, [open, filterList])

  const getPriorityStyle = (value) => {
    const baseStyle = {
      fontSize: 12,
      fontWeight: 'normal',
      padding: '5px 10px',
      textAlign: 'center',
      borderRadius: 5,
      display: 'inline-block',
      textTransform: 'uppercase',
      minWidth: '80px',
    }

    switch (value?.toUpperCase()) {
      case 'LOW':
        return { ...baseStyle, backgroundColor: '#3498db', color: '#ffffff' }
      case 'MEDIUM':
        return { ...baseStyle, backgroundColor: '#f39c12', color: '#ffffff' }
      case 'HIGH':
        return { ...baseStyle, backgroundColor: '#e67e22', color: '#ffffff' }
      case 'CRITICAL':
        return { ...baseStyle, backgroundColor: '#e74c3c', color: '#ffffff' }
      case 'MODERATE':
        return { ...baseStyle, backgroundColor: '#2ecc71', color: '#ffffff' }
      default:
        return { ...baseStyle, backgroundColor: '#95a5a6', color: '#ffffff' }
    }
  }

  return (
    <div>
      <Button
        aria-describedby={id}
        onClick={handleClick}
        variant="outlined"
        size="small"
        style={{
          marginLeft: 8,
          borderColor: filterList?.length > 0 ? '#1976d2' : '',
          backgroundColor: filterList?.length > 0 ? 'rgba(25, 118, 210, 0.08)' : '',
        }}
      >
        Priority Filter
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        PaperProps={{
          style: {
            backgroundColor: '#424242',
            color: '#ffffff',
            padding: '16px',
            width: '300px',
          },
        }}
      >
        <Box sx={{ p: 2 }}>
          <div className="filter-title">Priority Filters</div>
          <div style={{ maxHeight: '300px', overflow: 'auto', marginBottom: '16px' }}>
            {filterOptions.priorities?.map((priority, i) => {
              const style = getPriorityStyle(priority)
              return (
                <div key={i} style={{ display: 'flex', alignItems: 'center', margin: '6px 0' }}>
                  <Checkbox
                    checked={tempFilters.includes(priority)}
                    onChange={handleChange}
                    value={priority}
                    size="small"
                    style={{ color: '#ffffff' }}
                  />
                  <span style={{ ...style, marginLeft: '8px' }}>{priority}</span>
                </div>
              )
            })}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <button onClick={handleReset} className="reset-button-filter">
              Reset
            </button>
            <button onClick={handleApply} className="apply-button-filter">
              Apply
            </button>
          </div>
        </Box>
      </Popover>
    </div>
  )
}

export default PriorityFilter
